import Loader from "./Loader";
import CircleLoader from "./CircleLoader";

export default Loader;
export { CircleLoader };
